export const calendarInstructions = {
  googleCalendar: `1. Go to [Google Calendar](https://calendar.google.com) and log into your account
2. On the left, hover over the calendar you want to share, then click the **three-dot menu**
3. Click **Settings and sharing**
4. Scroll to **Integrate calendar** → under **Secret address in iCal format**, click **Copy**

> **Note:** The secret iCal url is usually the only link that will work for Google Calendar sync`,

  outlook: `1. Go to [Outlook on the web](https://outlook.live.com/calendar/) and sign in with your **Microsoft account** (e.g. @outlook.com, @hotmail.com)
2. Click the **Settings** (gear icon) → **View all Outlook settings**
3. Navigate to **Calendar** → **Shared calendars**
4. Under **Publish a calendar**, select your calendar and set permission to **Can view all details**
5. Click **Publish** → copy the **ICS link**

> **Note:** ICS links are usually only available for personal Microsoft accounts\
> If you're using a **work or school account**, calendar publishing is usually disabled by your organization`,

  iCal: `1. Open the **Calendar** app on your Mac
2. In the sidebar, right-click the iCloud calendar you want to share → choose **Share Calendar**
3. Check **Public Calendar** to enable it
4. Copy the **shareable link** (this is your ICS link)

> Or: go to [iCloud.com](https://www.icloud.com/), open **Calendar**, click the **share icon**, and enable **Public Calendar** to get the same link`,

  simplePractice: `1. Log into your [SimplePractice account](https://secure.simplepractice.com)
2. In the left-hand sidebar, click **Settings**
3. Under **Scheduling and inquiries**, select **Calendar**
4. Scroll to the **Apple Calendar** section
5. Click **Copy link** next to your secure calendar URL`,

  headway: `1. Visit your [Headway calendar settings](https://sigmund.headway.co/settings/calendar)
2. Scroll to the bottom of the page to the **Export Sigmund Calendar** section
3. Click **Copy** to copy your unique calendar URL`,

  alma: `1. Log into your [Alma provider portal](https://secure.helloalma.com)
2. In the left-hand sidebar, click **Calendar**
3. Scroll down to the **Export** section
4. Click **Copy** next to your unique calendar export URL`,

  therapyNotes: `1. Log into your [TherapyNotes](https://www.therapynotes.com) account
2. Go to the [Settings page](https://www.therapynotes.com/app/settings/)
3. Select **Sync Calendar With Other Applications**
4. Find the **Your personal calendar** link displayed on the page
5. **Highlight** the link text and copy it`
}
